module.exports = __webpack_public_path__ + "img/product_12.10e735ab.svg";